module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video_pick_panel section-white"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addVideo
    }
  }, [_vm._v("上传视频")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "video_pick"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.videoList.item), function(videoitem, index) {
    return _c('li', {
      key: index,
      staticClass: "video_item"
    }, [_c('div', {
      staticClass: "video_item_bd"
    }, [_c('video', {
      staticClass: "video-html",
      attrs: {
        "src": videoitem.url,
        "controls": "controls"
      }
    }, [_vm._v("\n            您的浏览器不支持 video 标签。\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "check_content"
    }, [_c('span', {
      staticClass: "video_name",
      attrs: {
        "title": videoitem.name
      }
    }, [_vm._v(_vm._s(videoitem.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "msg_card"
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', {
      staticClass: "opr_item",
      on: {
        "click": function($event) {
          return _vm.removeItem(videoitem, index)
        }
      }
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "删除",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    })])], 1)])], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tc"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "上传视频文件",
      "visible": _vm.uploadDialog,
      "before-close": _vm.handleCancel
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.videoForm,
        "label-width": "90px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "视频标题"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": "20"
      },
      model: {
        value: (_vm.videoForm.title),
        callback: function($$v) {
          _vm.$set(_vm.videoForm, "title", $$v)
        },
        expression: "videoForm.title"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "视频描述"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": "20"
      },
      model: {
        value: (_vm.videoForm.description),
        callback: function($$v) {
          _vm.$set(_vm.videoForm, "description", $$v)
        },
        expression: "videoForm.description"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "视频文件"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-upload', {
      staticClass: "upload-demo",
      attrs: {
        "action": "",
        "auto-upload": false,
        "show-file-list": false,
        "on-change": _vm.uploadVideo
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "loading": _vm.isLoadData
      }
    }, [_vm._v("上传视频")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("只能上传MP4文件，且不超过15M")])], 1)], 1)], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fd016f60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd016f60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/wechat/video/list.vue
// module id = 3000
// module chunks = 0